/* @ngInject */

function CustomSelects($timeout) {
  const utils = require('./utils').default;

  let globalDropdown;

  /*
   * Handler for the Escape key
   * dropdown: Instance of the dropdown to be used
   */
  const handleEscapeKey = (dropdown) => {
    dropdown.isOpen = false;
    removeClickListener(outsideClickListener);
    let list = document.getElementById(dropdown.listId);
    if (list) list.setAttribute('aria-expanded', 'false');
  };

  /*
   * Decide which item do we need to highlight when the user hovers or navigates with the keyboard
   * items: List of all country elements
   * direction: In case the user is using the keyboard (up or down)
   * id: Id for the container of the elements
   */
  const highlightItem = (items, direction, dropdown) => {
    let current = utils.getElementWithClass(items, 'highlight');
    utils.setElementsAttribute(items, 'aria-selected', false);
    let next;
    if (current) {
      if (direction === 'ArrowDown' && current !== items[items.length - 1]) {
        utils.cleanElementsClass(items, 'highlight');
        next = current.nextSibling.nextSibling;
        next.classList += ' highlight';
      } else if (direction === 'ArrowUp' && current !== items[0]) {
        utils.cleanElementsClass(items, 'highlight');
        next = current.previousSibling.previousSibling;
        next.classList += ' highlight';
      }
      if (next) {
        document
          .getElementById(dropdown.selectedItemId)
          .setAttribute('aria-activedescendant', next.getAttribute('id'));
        utils.scrollTo(next, dropdown.listId);
        next.setAttribute('aria-selected', 'true');
      }
    } else {
      items[0].classList += ' highlight';
      document
        .getElementById(dropdown.selectedItemId)
        .setAttribute('aria-activedescendant', items[0].getAttribute('id'));
      items[0].setAttribute('aria-selected', 'true');
    }
  };

  /*
   * Remove a click listener
   * listener: Reference to the listener function to be removed
   */
  const removeClickListener = (listener) => {
    document.removeEventListener('click', listener);
  };

  /*
   * Listener for the click outside the element
   * event: Event being triggered
   */
  const outsideClickListener = (event) => {
    let element = document.getElementById(globalDropdown.selectedItemId);
    let list = document.getElementById(globalDropdown.listId);
    if (element && !element.contains(event.target)) {
      if (utils.isVisible(element)) {
        let scope = angular.element(list).scope();
        if (scope) {
          $timeout(function () {
            scope.$apply();
          });
          element.setAttribute('aria-expanded', 'false');
        }
      }
      globalDropdown.isOpen = false;
      removeClickListener(outsideClickListener);
    } else if (!element) {
      globalDropdown.isOpen = false;
      removeClickListener(outsideClickListener);
    }
  };

  /*
   * Add click listener to manage click outside the element
   * dropdown: Instance of the dropdown to be used
   */
  const hideOnClickOutside = (dropdown) => {
    if (
      typeof globalDropdown === 'object' &&
      dropdown.name !== globalDropdown.name
    ) {
      removeClickListener(outsideClickListener);
      globalDropdown.isOpen = false;
      globalDropdown = dropdown;
      document.addEventListener('click', outsideClickListener);
    } else {
      globalDropdown = dropdown;
      document.addEventListener('click', outsideClickListener);
    }
  };

  /*
   * This function handles shows and hides the country list
   * dropdown: Instance of the dropdown to ge used
   */
  const toggleDropdown = (dropdown) => {
    let elem = document.getElementById(dropdown.selectedItemId);
    dropdown.isOpen = !dropdown.isOpen;
    if (globalDropdown && globalDropdown.type !== 'countryList')
      globalDropdown.isOpen = false;

    if (dropdown.isOpen) {
      hideOnClickOutside(dropdown);
    }
    if (elem) elem.setAttribute('aria-expanded', dropdown.isOpen);
  };

  /*
   * This function sets the selected country when the user clicks or uses the enter key
   * dropdown: Instance of the dropdown to be used
   * target: Target of the event being fired
   * country: The selected country
   */
  const setDropdownCountry = (dropdown, target, country) => {
    dropdown.selectedCountry = country;
    let event = new CustomEvent('countryChange', {
      detail: {
        country: country,
        phoneId: dropdown.phoneId,
        type: dropdown.name,
      },
    });

    window.dispatchEvent(event);
  };

  /*
   * This function handles the mouseover event on the list of countries
   * dropdown: Instance of the dropdown to be used
   * target: Target of the event being fired
   */
  const handleCountryMouseOver = (dropdown, target) => {
    // Get all highlighted elements and remove the highlighted class
    let highlighted = document
      .getElementById(dropdown.listId)
      .getElementsByClassName(dropdown.optionClass + ' highlight');
    if (highlighted.length !== 0)
      utils.cleanElementsClass(highlighted, 'highlight');

    // Check if current target is the list item or a child element
    // If is a child get the parent and highlight it
    if (target.classList.contains(dropdown.optionClass))
      target.className += ' highlight';
    else {
      let closest = utils.getClosest(target, '.' + dropdown.optionClass);
      if (closest) closest.className += ' highlight';
    }
  };

  /*
   * This function handles the mouseleave event on the list of countries
   * dropdown: Instance of the dropdown to be used
   */
  const handleMouseLeave = (dropdown) => {
    // Get all highlighted elements and remove the highlighted class
    let highlighted = document
      .getElementById(dropdown.listId)
      .getElementsByClassName(dropdown.optionClass + ' highlight');
    if (highlighted.length !== 0)
      utils.cleanElementsClass(highlighted, 'highlight');
  };

  /*
   * Handler for the Key down event
   * Here we check for up and down arrows, enter and escape keys
   * dropdown: Instance of the dropdown to be used
   * event: Event being fired
   */
  const handleKeyDown = (dropdown, event) => {
    // Manage up and down arrows
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!utils.isVisible(document.getElementById(dropdown.listId))) {
        event.preventDefault();
        toggleDropdown(dropdown);
      } else {
        event.preventDefault();
        let direction =
          event.key === 'ArrowDown' || event.key === 'ArrowUp'
            ? event.key
            : 'none';
        let items = document
          .getElementById(dropdown.listId)
          .getElementsByClassName(dropdown.optionClass);
        if (items && items.length > 0) {
          highlightItem(items, direction, dropdown);
        }
      }
    }

    // Manage Enter key
    if (event.key === 'Enter') {
      let list = document.getElementById(dropdown.listId);
      if (list) {
        let current = utils.getElementWithClass(
          list.getElementsByClassName(dropdown.optionClass),
          'highlight'
        );
        if (current) {
          if (dropdown.type === 'countryList') {
            let countryData = JSON.parse(current.getAttribute('data-country'));
            toggleDropdown(dropdown);
            setDropdownCountry(dropdown, current, countryData);
          } else {
            event.preventDefault();
            dropdown.isOpen = false;
            current.click();
          }
        }
      }
    }

    if (event.key === 'Escape' || event.key === 'Tab') {
      handleEscapeKey(dropdown);
    }
  };

  return {
    hideOnClickOutside: hideOnClickOutside,
    toggleDropdown: toggleDropdown,
    setDropdownCountry: setDropdownCountry,
    handleCountryMouseOver: handleCountryMouseOver,
    handleMouseLeave: handleMouseLeave,
    handleKeyDown: handleKeyDown,
  };
}

export default CustomSelects;
